export default {
    trailsDataBegin(state, query) {
        if (query) state.listQuery = query;
        state.loadingTrails = true;
    },
    trailsDataSuccess(state, data) {
        state.pageSize = Number((data.meta || data).per_page) || state.pageSize;
        state.trails = data.data;
        state.count = data.meta.total;
        state.currentPage = data.meta.current_page;
        state.loadingTrails = false;
    },
    trailsDataErr(state, err) {
        state.loadingTrails = false;
        state.errorTrails = err;
    },
    setCurrentPageTrail(state, page) {
        state.currentPage = page;
    },
};
